/** User-facing messages for PhoneInput RHF validate() branches. */
export function getPhoneValidationMessage(
  validationCountry: string,
  allowAllCountries: boolean
): string {
  const code = (validationCountry || "us").toLowerCase();
  if (code === "in") return "Please enter a valid Indian phone number";
  if (code === "us" && !allowAllCountries) return "Please enter a valid US phone number";
  return "Please enter a valid phone number";
}